import { faker } from '@faker-js/faker';

import type { MaoAirport, MaoLocation } from '#entities';

export const generateLocation = (aircraftId: number): MaoLocation => ({
  AircraftId: aircraftId,
  Heading: faker.number.float({ min: 0, max: 360 }),
  Latitude: faker.location.latitude(),
  Longitude: faker.location.longitude(),
  LocationTimestamp: faker.date.past().toISOString(),
});

export const generateAirport = (location?: MaoLocation): MaoAirport => {
  const iata = faker.airline.airport().iataCode;
  return {
    Country: {
      Name: 'US',
    },
    ServedCity: faker.location.city(),
    ICAO: `K${iata}`,
    IATA: iata,
    IanaTimeZone: 'America/New_York',
    Id: faker.number.int({ min: 1 }),
    Latitude: location ? location.Latitude : faker.location.latitude(),
    Longitude: location ? location.Longitude : faker.location.longitude(),
    ServedCityArea: {
      Code: faker.location.zipCode(),
    },
  };
};
